import React from 'react'
import Layout from '../../../shared/components/organisms/layout/layout'
import useMediaQuery from '../../../utils/useMediaQuery'
import ModalViewer from '../../organisms/modal-viewer/modal-viewer'
import AppSEO from '../../atoms/app-seo/app-seo'

import './page-layout.scss'

const PageLayout = ({ children }) => {
  let isMobile = useMediaQuery()

  return (
    <Layout mobile={isMobile}>
      <AppSEO />
      <ModalViewer />
      <div className="f-page-layout__container">{children}</div>
    </Layout>
  )
}

export default PageLayout
